import Api from 'libs/api';
import AuthService from 'services/Auth';
import axios from 'axios';

class ReservationsApi extends Api {
  constructor(restaurantID) {
    const resId = restaurantID || AuthService.getCurrentRestaurant();
    super(`admin/restaurants/${resId}/reservations`);
  }

  updateStatus = (id, params) => {
    return this.buildQuery('post', params, `${id}/update_status`);
  };

  getExcel = (params = {}) => {
    return axios({
      url: `${this.url}.xlsx`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };

  getPdf = (params = {}) => {
    return axios({
      url: `${this.url}.pdf`,
      method: 'get',
      data: params.data,
      params: params.params,
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json',
        ...(params?.headers || {}),
        'auth-token': AuthService.getToken(),
      },
    });
  };
}

export default ReservationsApi;
